export const isOfflineDocsBuild = process.env['OFFLINE_DOCS'] === 'true';
